import React from 'react';

const getOpeningHours = day => {
  if (!day?.isOpen) {
    return 'Closed';
  }

  return `${day?.openingHours?.replace(
    /^0(?:0:0?)?/,
    ''
  )} - ${day?.closingHours?.replace(/^0(?:0:0?)?/, '')}`;
};

const findDayOfWeek = (days, day) =>
  days.find(activeDay => activeDay.dayOfWeek === day);

export type OpeningHoursProps = {
  hours: {
    dayOfWeek?: string;
    isOpen?: boolean;
    openingHours?: string;
    closingHours?: string;
  }[];
  additionalInfo?: string;
  isCompanyOwned?: boolean;
  hasStorefront?: boolean;
};

function OpeningHours({
  hours,
  additionalInfo = '',
  isCompanyOwned = false,
  hasStorefront = false,
}: Readonly<OpeningHoursProps>) {
  const widthClasses =
    isCompanyOwned && !hasStorefront
      ? 'hidden'
      : 'w-full md:[width:calc(50%-0.5rem)] lg:[width:calc(40%-0.5rem)]';

  return (
    <div className={`${widthClasses} [&_p]:my-[0.375rem]`}>
      <h2>{isCompanyOwned ? 'Walk-In Store Hours' : 'Operating Hours'}</h2>

      {hours?.length > 0 && (
        <div>
          <p>Mon: {getOpeningHours(findDayOfWeek(hours, 'monday'))}</p>
          <p>Tue: {getOpeningHours(findDayOfWeek(hours, 'tuesday'))}</p>
          <p>Wed: {getOpeningHours(findDayOfWeek(hours, 'wednesday'))}</p>
          <p>Thu: {getOpeningHours(findDayOfWeek(hours, 'thursday'))}</p>
          <p>Fri: {getOpeningHours(findDayOfWeek(hours, 'friday'))}</p>
          <p>Sat: {getOpeningHours(findDayOfWeek(hours, 'saturday'))}</p>
          <p>Sun: {getOpeningHours(findDayOfWeek(hours, 'sunday'))}</p>
        </div>
      )}
      {additionalInfo && (
        <div className="mt-4">
          <p>{additionalInfo}</p>
        </div>
      )}
    </div>
  );
}

export default OpeningHours;
